import React from 'react';
import { Grid, Theme, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Image from 'components/common/Image';
import { useRouter } from 'next/router';
import { routes } from '../../../utils/routing';

interface OrgCardProps {
  id?: string;
  title: string;
  logo?: string;
  tagline?: string;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    height: `calc(100% + ${theme.spacing(2)})`,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      aspectRatio: 1,
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  imageContainer: {
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 16,
    },
  },
  title: {
    wordBreak: 'break-word',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '120%',
    color: '#383C44',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    marginLeft: 12,
  },
  tagline: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '160%',
    color: '#383C44',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 3,
    maxHeight: 63,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    paddingLeft: 8,
  },
  taglineContainer: {
    marginTop: 16,
  },
}));

const UserOrgCard: React.FC<React.PropsWithChildren<OrgCardProps>> = (props) => {
  const { logo, title, tagline, id } = props;
  const { classes } = useStyles();

  const router = useRouter();
  const onClick = () => {
    const route = routes.organizationProfile(id);
    router.push(route.href);
  };
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Grid className={classes.root} container spacing={1} alignContent="flex-start" onClick={onClick}>
      {isMobile && (
        <Grid item xs={12} key={id}>
          <div className={classes.imageContainer}>
            <Image objectFit="contain" variant="square" rounded src={logo} alt={title} />
          </div>
        </Grid>
      )}
      {!isMobile && (
        <Grid xs={12}>
          <Grid container spacing={1}>
            {logo && (
              <Grid xs={3}>
                <div className={classes.imageContainer}>
                  <Image variant="square" rounded src={logo} alt={title} />
                </div>
              </Grid>
            )}
            <Grid item xs={logo ? 8 : 12}>
              <Typography className={classes.title}>{title}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!isMobile && tagline && (
        <Grid item xs={12} className={classes.taglineContainer}>
          <Typography className={classes.tagline} color="textPrimary" variant="h6" component="p">
            {tagline}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default UserOrgCard;
